module.exports = __webpack_public_path__ + "media/images/oneonone-9983b9388cc045b512626af9372da250f1835fff3c390c863b75782e27bbb3c2.jpg";